import store from '../store/store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('persistFlightStatus', function persistFlightStatus(
    isInTreatmentFlight: boolean
) {
    store.isInTreatmentFlight = isInTreatmentFlight;
});
